import api from '../api/'

export const nf = {
    state: { notas: [], movimentos:[], notasFiltradas: [], tabsFiliais: [], isLoading: false },
	reducers: {
		ListaNotas: (state, notasPLug) => {
            console.log('::: REDUCER: listaNFEs FILL notas: ', notasPLug)
            return {
                ...state,
                notas: notasPLug
            }
        },
        ListaMovimentos: (state, movimentos) => {
            console.log('::: REDUCER: Lista Movimentos: ', movimentos)
            return {
                ...state,
                movimentos: movimentos
            }
        },
        setIsLoading: (state, payload) => {
            return {
                ...state,
                isLoading: payload
            }
        },
        setAtualizarTabs: (state, payload) => {
            return {
                ...state,
                tabsFiliais: payload
            }
        },
        listaNFEsFiltradas: (state, payload) => {
            return {
                ...state,
                notasFiltradas: [...state.notasFiltradas, payload]
            }
        },
        LimparNotas: (state) => {
            return {
                ...state,
                notas: []
            }
        },
        LimparTabs: (state) => {
            return {
                ...state,
                tabsFiliais: []
            }
        },
        adicionarFiliais: (state, payload) => {
            console.log('adicionarFiliais', payload);
            return {
                ...state,
                tabsFiliais: [...state.tabsFiliais, payload]
            }
        },
       
	},
	effects: (dispatch) => ({
        
		async asyncListarNFEs(payload) {
            console.log('DATAS ENVIADAS RANGE:', payload)

			await api.get('/Movimento/ConsultarEmissaoNfseDatas/' + payload.dataInicio + '/' + payload.dataFim, {
                headers: { 'Content-Type': 'application/json' }
            }).then(function (response) {
                console.log(':::: NOVAS NOTAS SELECIONADAS PELA DATA:', response)
                dispatch.nf.ListaNotas(response.data)
            }).catch(function (error) {
                const listaVazia = [];
                dispatch.nf.ListaNotas(listaVazia);
                console.log('[!]Erro no efeito: asyncListarNFEs: ', error) 
            });
        },

        async asyncListarDOCS(data) {    
			await api.post('/Movimento', data,  {headers: {'Content-Type': 'application/json'}
            }).then(function (response) {
                console.log(':::: Movimento [SUCESSO] ::::', response);
                dispatch.nf.ListaNotas(response.data);
            }).catch(function (error) {
                console.log('Movimento route: [ERROR]:', error);
                const listaVazia = [];
                dispatch.nf.ListaNotas(listaVazia);
            }); 
        },

        async asyncListarNotasFiltradas(payload) {
            console.log(':::: NOTAS FILTRADAS PELA BUSCA TEXTUAL')
            dispatch.nf.listaNFEsFiltradas(payload)
        },

        async asyncAdicionarFiliais(payload) {
            console.log('::::: ADICIONANDO UMA TAB FILIAL', payload)
            dispatch.nf.adicionarFiliais(payload)
       },

       async asyncAtulizaTodasTabs(payload) {
            console.log(':::: SUBSTITUI TODAS AS TABS:', payload)
            dispatch.nf.setAtualizarTabs(payload)
       },
      
	}),
}
